"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentAccountIdProvider = exports.useCurrentAccountId = void 0;
const react_1 = __importStar(require("react"));
const useLocalStorage_1 = require("../useLocalStorage");
const CurrentAccountIdContext = react_1.createContext(undefined);
exports.useCurrentAccountId = () => react_1.useContext(CurrentAccountIdContext);
exports.CurrentAccountIdProvider = (props) => {
    const [currentAccountId, setCurrentAccountId] = useLocalStorage_1.useLocalStorage('currentAccountId');
    react_1.useEffect(() => {
        if (props.currentAccountId && currentAccountId !== props.currentAccountId) {
            setCurrentAccountId(props.currentAccountId);
        }
    }, [props.currentAccountId, currentAccountId, setCurrentAccountId]);
    return (react_1.default.createElement(CurrentAccountIdContext.Provider, { value: currentAccountId }, props.children));
};
